export const INITIAL_POSTS_COUNT = 5;
export const INITIAL_YEAR = 2020;
